import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <main className="bg-zinc-950 min-h-screen" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ServicesSection data-id="element-2" />
      <TestimonialsSection data-id="element-3" />
      <AboutSection data-id="element-4" />
      <FooterSection data-id="element-5" />
    </main>;
}